"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _react = _interopRequireDefault(require("react"));

var _index = require("./index.styles"); // Copyright © VNG Realisatie 2020
// Licensed under the EUPL
//


var Spinner = function Spinner(_ref) {
  var props = (0, _extends2["default"])({}, _ref);
  return /*#__PURE__*/_react["default"].createElement(_index.StyledSvg, (0, _extends2["default"])({
    viewBox: "0 0 24 24"
  }, props), /*#__PURE__*/_react["default"].createElement("path", {
    fill: "none",
    d: "M0 0h24v24H0z"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M18.364 5.636L16.95 7.05A7 7 0 1019 12h2a9 9 0 11-2.636-6.364z"
  }));
};

var _default = Spinner;
exports["default"] = _default;